import { createRoot } from "react-dom/client";
import { polyfill } from "mobile-drag-drop";
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";
import App from "./App.tsx";
import "./index.css";
import { i18nReady } from "./i18n/i18n";

polyfill({
  holdToDrag: 300,
  dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
});

// Log Gemini key source at startup (dev only). Pollinations for images is server-side only in production.
const geminiInEnv = !!(import.meta.env.VITE_GEMINI_API_KEY as string)?.trim();
if (import.meta.env.DEV) {
  console.log("[AUTH] Gemini key in ENV:", geminiInEnv);
  if (!geminiInEnv) {
    console.warn("[AUTH] No VITE_GEMINI_API_KEY in .env — add it for dev, or use Settings. Image generation uses server-side POLLINATIONS_API_KEY.");
  }
}

i18nReady.then(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});
